<template>
    <div class="task-cell" @mouseenter="showOverlay = true" @mouseleave="showOverlay = false">
        <div v-if="task" class="task-info" @click="viewTask(task)">
            <FieldIcon type="task" :size="16" class="task-icon" :default-icon="field.icon" />
            <span class="task-title">{{ task.title }}</span>
        </div>
        <PermissionController :permissions="['table.update']" v-else>
            <a @click="showTaskPicker">+ Task Ekle</a>
        </PermissionController>

        <div v-if="showOverlay && task && !readonly" class="overlay-actions">
            <PermissionController :permissions="['table.update']">
                <a-button icon="edit" size="small" @click="editTask" style="margin-right: 4px" />
            </PermissionController>
            <PermissionController :permissions="['table.update']">
                <a-button icon="delete" type="danger" size="small" @click="removeTask" />
            </PermissionController>
        </div>

        <Modal2
            v-if="showModal"
            @cancel="closeModal"
            :title="'Task Seç'"
            :okText="'Kaydet'"
            xlarge
            className="task-picker-modal keydown-prevent-modal"
        >
            <TaskListView picker-mode @selected="onTaskSelected" />
        </Modal2>
    </div>
</template>

<script>
import Vue from "vue";
import Modal2 from "../../../../../components/common/Modal2.vue";
import TaskListView from "../../../../../components/task/TaskListView.vue";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";
import { mapActions } from "vuex";
import FieldIcon from "../../FieldIcon.vue";

export default Vue.extend({
    name: "TaskCell",
    components: {
        Modal2,
        TaskListView,
        SupsisButton,
        FieldIcon,
    },
    props: {
        record: {
            type: Object,
            required: true,
        },
        field: {
            type: Object,
            required: true,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            showModal: false,
            showOverlay: false,
            hideTimeout: null,
        };
    },
    computed: {
        task() {
            const taskId = this.record.data[this.field._id];
            if (typeof taskId === "string") {
                return this.$store.state.tasks.tasks.find((task) => task._id === taskId) || null;
            }
            return taskId || null;
        },
    },
    methods: {
        ...mapActions({
            addNewWindow: "app/addNewWindow",
        }),
        viewTask(task) {
            this.addNewWindow({
                type: "editor-task",
                title: task.title,
                payload: {
                    taskId: task._id,
                },
                autoClose: false,
            });
        },
        showTaskPicker() {
            if (this.readonly) {
                this.$message.error("Seçim modu içinde bu alanı düzenleyemezsiniz");
                return;
            }
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
        async onTaskSelected(task) {
            try {
                await this.$emit("update-record", {
                    recordId: this.record._id,
                    fieldId: this.field._id,
                    value: task._id,
                });
                this.closeModal();
            } catch (error) {
                console.error("Kayıt güncellenirken hata oluştu:", error);
                this.$message.error("Kayıt güncellenirken bir hata oluştu");
            }
        },
        editTask() {
            if (this.readonly) {
                this.$message.error("Seçim modu içinde bu alanı düzenleyemezsiniz");
                return;
            }
            this.showTaskPicker();
        },
        async removeTask() {
            if (this.readonly) {
                this.$message.error("Seçim modu içinde bu alanı düzenleyemezsiniz");
                return;
            }
            try {
                await this.$emit("update-record", {
                    recordId: this.record._id,
                    fieldId: this.field._id,
                    value: null,
                });
                this.$message.success("Task başarıyla kaldırıldı");
            } catch (error) {
                console.error("Task kaldırılırken hata oluştu:", error);
                this.$message.error("Task kaldırılırken bir hata oluştu");
            }
        },
        hideMenu() {
            this.hideTimeout = setTimeout(() => {
                this.showMenu = false;
            }, 200);
        },
        cancelHide() {
            clearTimeout(this.hideTimeout);
        },
    },
});
</script>

<style scoped lang="scss">
.task-cell {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding: 4px 8px;

    .task-info {
        display: flex;
        align-items: center;
        gap: 4px;
        cursor: pointer;
        padding: 4px;
        border-radius: 4px;
        transition: background-color 0.2s ease;

        .task-title {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        &:hover {
            background: var(--color-bg-neutral-hover);
        }
    }

    .overlay-actions {
        position: absolute;
        top: 2px;
        right: 2px;
        display: flex;
        gap: 4px;
        z-index: 10;
    }
}
</style>
